










import {Component, Vue} from 'vue-property-decorator';
import DynamicComponents from '@/components/DynamicComponents.vue';
import {SDynamicComponent} from '@/components/dto/SDynamicComponent';
import {ScomponentMode} from '@/components/dto/ScomponentMode';
import {ScomponentModeImpl} from '@/components/dto/ScomponentModeImpl';


@Component({
    components: {DynamicComponents}
})
export default class Login extends Vue {
    private mode: ScomponentMode = ScomponentModeImpl.prototype.empty();
    private schema: SDynamicComponent[] = this.formSchema();
    private data: any = this.formData();
    private alert: SDynamicComponent = this.alertSchema();

    handle_function_call(e: any, param: any):void {
        if(Array.isArray(param)){
            //@ts-ignore
            this[e].apply(this, param);
        }else{
            //@ts-ignore
            this[e](param);
        }
    };


    loginUser(){
        let user = {
            username: this.data.username.value,
            password: this.data.password.value
        };
        if(user.username == "" || user.password == ""){
            this.loginAlert('login.errors.404');
            return;
        }
        this.$store.dispatch('login', user)
            .then(() => {
            this.$router.push({name: 'profile'});
        }).catch(err => {
            this.loginAlert('login.errors.404');
            console.log(err);
        });

    }

    loginAlert(message: string){
        let newSchema: SDynamicComponent[] = [];
        this.alert.data.message = this.$i18n.t(message);
        newSchema.push(this.alert);
        newSchema.push(...this.schema);
        this.schema = newSchema;
    }

    formData(): any {
        return {"username": {
                "value": ''
            },
            "password": {
                "value": ''
            }

        };
    };

    alertSchema(): SDynamicComponent{
        return{
            "component": {
                "uid": "",
                "name": "Alerts",
                "url": "http://localhost:5000/alerts.umd.min.js"
            },
            "data": {
                "dismiss_label": "dismissLabel",
                "dismissSecs": 0,
                "dismissible": true,
                "fade": false,
                "message": "Alert",
                "show": true,
                "variant": "danger"
            },
            "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
        };
    };

    formSchema() : SDynamicComponent[]{
        return [

            {
            "component": {
                "uid": "",
                "name": "Form",
                "url": "http://localhost:5000/form.umd.min.js"
            },
            "data": {
                "body": [{
                    "component": {
                        "uid": "",
                        "name": "Card",
                        "url": "http://localhost:5000/card.umd.min.js"
                    },
                    "data": {

                        "title": this.$i18n.t('login.title'),
                        "body": [{
                            "component": {
                                "uid": "",
                                "name": "FormGroup",
                                "url": "http://localhost:5000/form-group.umd.min.js"
                            },
                            "data": {
                                "id": "fieldset-username",
                                "label": "Login name:",
                                "label_cols" : 4,
                                "label_cols_lg": 2,
                                "label_for": "username",
                                "body":[
                                    {
                                        "component": {
                                            "uid": "",
                                            "name": "FormInput",
                                            "url": "http://localhost:5000/form-input.umd.min.js"
                                        },
                                        "data": {
                                            "id": "username",
                                            "name": "username_",
                                            "required": true,
                                            "placeholder": "Your login",
                                            "body": []
                                        },
                                        "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                    }
                                ]
                            },
                            "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                        },{
                            "component": {
                                "uid": "",
                                "name": "FormGroup",
                                "url": "http://localhost:5000/form-group.umd.min.js"
                            },
                            "data": {
                                "id": "fieldset-password",
                                "label": "Password:",
                                "label_cols" : 4,
                                "label_cols_lg": 2,
                                "label_for": "password",
                                "body":[
                                    {
                                        "component": {
                                            "uid": "",
                                            "name": "FormInput",
                                            "url": "http://localhost:5000/form-input.umd.min.js"
                                        },
                                        "data": {
                                            "id": "password",
                                            "name": "password_",
                                            "required": true,
                                            "placeholder": "Your password",
                                            "type":"password",
                                            "body": []
                                        },
                                        "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                    }
                                ]
                            },
                            "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                        },
                            {
                                "component": {
                                    "uid": "",
                                    "name": "ButtonGroup",
                                    "url": "http://localhost:5000/button-group.umd.min.js"

                                },
                                "data": {
                                    "body":[{
                                        "component": {
                                            "uid": "",
                                            "name": "Button",
                                            "url": "http://localhost:5000/button.umd.min.js"

                                        },
                                        "data": {
                                            "uid": 12,
                                            "button_text": "Login",
                                            "variant": "primary",
                                            "type": "submit",
                                            "size": "",
                                            "fn_name": "loginUser"
                                        },
                                        "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                    },{
                                        "component": {
                                            "uid": "",
                                            "name": "Button",
                                            "url": "http://localhost:5000/button.umd.min.js"

                                        },
                                        "data": {
                                            "uid": 122,
                                            "button_text": "Create account",
                                            "to": {name : "registration"}
                                        },
                                        "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                                    }]
                                },
                                "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                            }],
                    },
                    "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
                }],
            },
                "componentMode":{editable:false,delete:false,addHint:false, moveComponent:false}
        }]
    };

}
